import { Modal } from "bootstrap";

import { AssistantContactFormResponseModel } from "./assistant-contact-form-response.model";

export class AssistantContactFormComponent {

    private _form: JQuery = null;
    private _currentContext: JQuery = null;
    private _warning: JQuery = null;
    private _contactMethod: JQuery = null;
    private _email: JQuery = null;
    private _phone: JQuery = null;
    private _modal: Modal = null; // we use bootstrap.Modal as workaround for cookiebot issue to fix bug ".modal(...) is not a function"

    private bindEvents(): void {
        this._form.on("submit", (event) => {
            if (!this._form.valid()) {
                return;
            }

            this._warning.hide();
            event.preventDefault();

            const formValues = $(this._form).serialize();
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const _ = $.post("/api/assistants-profile-details/contact", formValues)
                .done((data: AssistantContactFormResponseModel) => {
                    if (data?.success) {
                        this._modal.hide();
                        this._form.trigger("reset");
                    } else {
                        this._warning.show();
                    }
                })
                .fail(() => {
                    this._warning.show();
                });
        });

        this._contactMethod.on("change", (event) => {
            const value = $(event.target).val();
            this._email.toggle(value === "Email");
            this._phone.toggle(value !== "Email");
        });
    }

    private parseContext(): void {
        this._warning = $(".js-pcg-validation-result", this._currentContext);
        this._form = $(".js-pcg-contact-form", this._currentContext);
        this._contactMethod = $(".js-pcg-custom-radio--contact-method", this._currentContext);
        this._email = $(".js-pcg-form-group-email", this._currentContext);
        this._phone = $(".js-pcg-form-group-phone", this._currentContext);
        this._modal = new Modal(this._currentContext[0], {} as Partial<Modal.Options>);
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvents();
    }

    public static init(context: JQuery): AssistantContactFormComponent {
        const component = new AssistantContactFormComponent();
        component.init(context);
        return component;
    }
}
